export default __webpack_public_path__ + "static/media/icon-wal.40824399.svg";